import { useCallback, useEffect, useRef, useState } from 'react'

const useIsImgLoad = (isSuccess: boolean) => {
  const [isBanner1Load, setIsBanner1Load] = useState(false)
  const [isBanner2Load, setIsBanner2Load] = useState(false)
  const [isImgLoad, setIsImgLoad] = useState(false)
  const banner1Ref = useRef<HTMLImageElement>(null)
  const banner2Ref = useRef<HTMLImageElement>(null)

  const createUpdateImgLoad = (img: HTMLImageElement, setLoadState: (state: boolean) => void) => {
    const isImageLoad = img.complete && (!!img.naturalHeight || !!img.alt)
    setLoadState(isImageLoad)
  }

  const createImageLoadHandler = useCallback((
    imgRef: React.RefObject<HTMLImageElement>,
    setLoadState: (state: boolean) => void,
  ) => {
    return () => {
      if (!imgRef.current) {
        setLoadState(false)
        return
      }

      const updateImgLoad = () => createUpdateImgLoad(imgRef.current as HTMLImageElement, setLoadState)

      imgRef.current.addEventListener('load', updateImgLoad, { once: true })
      imgRef.current.addEventListener('error', updateImgLoad, { once: true })

      return () => {
        imgRef.current?.removeEventListener('load', updateImgLoad)
        imgRef.current?.removeEventListener('error', updateImgLoad)
      }
    }
  }, [])

  useEffect(() => {
    const handler1 = createImageLoadHandler(banner1Ref, setIsBanner1Load)
    if (handler1) handler1()
  }, [isSuccess, banner1Ref, createImageLoadHandler])

  useEffect(() => {
    const handler2 = createImageLoadHandler(banner2Ref, setIsBanner2Load)
    if (handler2) handler2()
  }, [isSuccess, banner2Ref, createImageLoadHandler])

  useEffect(() => {
    setIsImgLoad(isBanner1Load && isBanner2Load)
  }, [isBanner1Load, isBanner2Load])
  
  return { isImgLoad, banner1Ref, banner2Ref }
}
export default useIsImgLoad
